// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3qU6s","fileBtn":"File_fileBtn__3AOZZ","closeBtn":"File_closeBtn__14y3u","fileSelected":"File_fileSelected__3mZNE","disabled":"File_disabled__2JMg2"};